/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { APP_BASE_HREF } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SwitchToBusinessService, SwitchToComponent } from '@gh/builder-shared';
import { APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER } from '@gh/builder-shared-data';
import { NotFoundPageComponent } from '@gh/common-internal-shared';
import { createRoute, DeepLinkActivateService } from '@gh/common-shared';

import { getBuilderBootstrapParams } from './builder-app.utils';

// @ts-ignore
const routes: Routes = [{
  path: '',
  pathMatch: 'full',
  redirectTo: 'dashboard',
}, {
  path: 'paypal',
  pathMatch: 'prefix',
  redirectTo: '/dashboard',
}, createRoute({
  component: SwitchToComponent,
  path: 'switch-to',
  init: SwitchToBusinessService,
  auth: {
    applicationView: [APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER],
  },
}), {
  path: 'dashboard',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-dashboard/builder-dashboard.module').then(m => m.BuilderDashboardModule),
}, {
  path: 'contracts-manager',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-cm/builder-cm.module').then(m => m.BuilderCmModule),
}, {
  path: 'house-land',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-hlp/builder-hlp.module').then(m => m.BuilderHlpModule),
}, {
  path: 'setup',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-setup/builder-setup.module').then(m => m.BuilderSetupManagementModule),
}, {
  path: 'ael',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-ael/builder-ael.module').then(m => m.BuilderAelModule),
}, {
  path: 'stl',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-stl/builder-stl.module').then(m => m.BuilderStlModule),
}, {
  path: 'xero-issue-log',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-accounting/builder-accounting.module').then(m => m.BuilderAccountingModule),
}, {
  path: 'send-to-office',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-office-export/builder-office-export.module').then(m => m.BuilderHpExportModule),
}, {
  path: 'job-admin',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-job-admin/builder-job-admin.module').then(m => m.BuilderJobAdminModule),
}, {
  path: 'butl',
  loadChildren: () => import('./butl/builder-butl.module').then(m => m.BuilderButlModule),
}, {
  path: 'contacts',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-contacts/builder-contacts.module').then(m => m.BuilderContactsModule),
}, {
  path: 'sms',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-sms/builder-sms.module').then(m => m.BuilderSmsModule),
}, {
  path: 'todo',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-todo/builder-todo.module').then(m => m.BuilderTodoModule),
}, {
  path: 'master-zones',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-master-zones/builder-master-zones.module').then(m => m.BuilderMasterZonesModule),
}, {
  path: 'sales',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-sales/builder-sales.module').then(m => m.BuilderSalesModule),
}, {
  path: 'manager',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-manager/builder-manager.module').then(m => m.BuilderManagerModule),
}, {
  path: 'estimating',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-estimating/builder-estimating.module').then(m => m.BuilderEstimatingModule),
}, {
  path: 'schedules',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-scheduling/builder-scheduling.module').then(m => m.BuilderSchedulingModule),
}, {
  path: 'accounting',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-accounting/builder-accounting.module').then(m => m.BuilderAccountingModule),
}, {
  path: 'gto',
  // @ts-ignore
  loadChildren: () => import('@gh/builder-gto/builder-gto.module').then(m => m.BuilderGtoModule),
}, {
  path: 'deep-links',
  pathMatch: 'prefix',
  children: [{
    canActivate: [DeepLinkActivateService],
    canActivateChild: [DeepLinkActivateService],
    path: '**',
    children: [],
  }],
}, {
  path: '404',
  component: NotFoundPageComponent,
}, {
  path: '**',
  component: NotFoundPageComponent,
}];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'disabled',
  })],
  providers: [{
    provide: APP_BASE_HREF,
    useValue: getBuilderBootstrapParams().baseUrl,
  }],
  declarations: [],
  exports: [RouterModule],
})
export class BuilderAppRoutingModule {
}
